import type { Session } from '../../domain/entities/session';
import type { AuthRepository } from '../../domain/ports/auth-repository';
import type { SessionFactory } from '../ports/session-factory';

export interface VerifyEmailOtpInput {
  mfaToken: string;
  code: string;
  email: string;
}

interface VerifyEmailOtpUseCaseDeps {
  authRepository: AuthRepository;
  createSession: SessionFactory;
}

export async function verifyEmailOtpUseCase(
  input: VerifyEmailOtpInput,
  deps: VerifyEmailOtpUseCaseDeps,
): Promise<Session> {
  const result = await deps.authRepository.verifyMfaEmailOtp({
    mfaToken: input.mfaToken,
    code: input.code,
  });
  const session = deps.createSession({ ...result, email: input.email });
  if (!session) throw new Error('invalid token in response');

  return session;
}
